import { withChartLayout } from 'components/common';
import SavedSystemNursingInterventions from 'components/features/chart/system-nursing-interventions/saved-system-nursing-interventions/SavedSystemNursingInterventions';

const SavedSystemNursingInterventionsPage = withChartLayout('Saved System Nursing Interventions')(SavedSystemNursingInterventions);
export default SavedSystemNursingInterventionsPage;
